<template>
<div style="min-height: 100vh">
    <header>{{ title }}<div class="h-left"><a @click="$router.go(-1)"><img src="~@/assets/images/icon02.svg"></a></div>
    </header>
    <div id="wrap">
        <div class="txt-area" id="other_site_content" v-html="content">
        </div>
    </div>
</div>
</template>

<script>
import {
  mapActions,
  mapGetters
} from "vuex"
import CONSTANTS from "@/constants"
export default {
    data: () => ({
        title: null,
        content: null,
    }),
    computed: {
        ...mapGetters(["metadata"]),
    },
    async mounted() {
        if (!this.metadata) {
            await this.getMetadata()
        }
        this.showOtherSites(this.$route.query.site_name)
        
        window.scrollTo(0, 0)
    },
    methods: {
        ...mapActions({
            getMetadata: 'metadata/getMetadata',
        }),
        showOtherSites(site) {
            let slug = "";
            if (site == "operating_company") {
                slug = "company_page";
            } else if (site == "terms_of_use") {
                slug = "security_page";
            } else if (site == "privacy_policy") {
                slug = "privacy_policy";
            } else if (site == "commercial_law_show") {
                slug = "legal_1";
            } else if (site == "fund_law_show") {
                slug = "legal_2";
            } else if (site == "guide") {
                slug = "guide";
            } else if (site == "help_page") {
                if (parseInt(this.userDetail.sex) === CONSTANTS.MALE) {
                    slug = "help_page_male"
                } else {
                    slug = "help_page_female"
                }
            }

            let pages = this.metadata.pages.result;
            for (var page of pages) {
                if (page.slug == slug) {
                    this.title = page.title
                    break
                }
            }

            // Content
            let site_content = '';
            if (process.env.NODE_EN == 'production') {
                site_content = CONSTANTS.CONTENT_URL_LIVE + 'content/greedgreed/' + slug;
            } else {
                site_content = CONSTANTS.CONTENT_URL_STG + 'content/greed-greed-stg/' + slug;   // gg.widocom.com
                // site_content = CONSTANTS.CONTENT_URL_STG + 'content/greed_greed_dev/' + slug;      // ggdev.widocom.com
            }

            this.$store
                .dispatch("user/loadPage", site_content)
                .then((data) => {
                    this.content = data;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
};
</script>
